























import { Vue, Component } from 'vue-property-decorator';
import VoteList from './components/VoteList.vue';
import * as config from './config';
@Component({
  name: 'WinnerList',
  components: {
    VoteList,
  },
})
export default class WinnerList extends Vue {
  options = config.OPTHINES;

  listType: number = 1;
  handleClickToDetail(type: string, id: string) {
    this.$router.push({
      name: 'VoteForDetail',
      query: {
        type,
        id: id[0],
      },
    });
  }
}
